import { render, staticRenderFns } from "./hot.vue?vue&type=template&id=bd6dca4c&"
import script from "./hot.ts?vue&type=script&lang=ts&"
export * from "./hot.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports